import { useApplicationContext } from '@/app/shared/context/ApplicationContext';

import { useCardOfferDataContext } from '../../../context/selectors';
import { EVas, type IVas } from '../../../types/vas';
import { getDescription, getName, sortVas } from '../utils';

export const usePromotionTooltipItems = (): IVas[] => {
  const { config } = useApplicationContext();
  const {
    geo,
    extendedProperties: { offerServices },
  } = useCardOfferDataContext();
  const { isAuction, isTop3, isPremium, isStandard } = offerServices || {};
  const offerLocation = geo && geo.address && geo.address.length > 0 ? geo.address[0] : null;
  const mlSearchRegions = config.get<number[]>('mlSearchRegions') || [];
  const isMlSearchForAll = config.get<boolean>('isMlSearchForAll.Enabled') || false;

  const isMLSearchByRegion = !!offerLocation && (mlSearchRegions || []).includes(offerLocation.id);
  const isMLSearch = isMlSearchForAll || isMLSearchByRegion;

  const vasList = [
    isAuction && EVas.Auction,
    isTop3 && EVas.Top,
    isPremium && EVas.Premium,
    isStandard && EVas.Standard,
  ].filter(Boolean) as EVas[];

  return sortVas(vasList).map(vas => ({
    type: vas,
    name: getName(vas, isMLSearch),
    description: getDescription(vas, isMLSearch),
  }));
};
